import React from 'react';
import {observer} from 'mobx-react';
import {FormLayout, Input, ActionLink} from 'components';
import _ from 'lodash';
import {FormattedMessage} from 'react-intl';
import {t} from 'shared/core';

const TieredCoverageVolumeForm = observer(({uiState}) => {
  const {currentCoverage, errors} = uiState;

  return (
    <FormLayout>
      {currentCoverage.coverageVolumeTiers.map(tier =>
        <div key={tier.order}>
          <div className='table'>
            <div className='col-6 table-cell align-middle medium'>
              <FormattedMessage id='taxable_benefits.COVERAGE_TIER' values={{index: tier.order + 1}} />
            </div>
            <div className='col-6 table-cell align-middle right-align'>
              {uiState.showCoverageTierRemoveLink && <ActionLink subdued onClick={() => uiState.removeCoverageVolumeTier(tier)}>
                <FormattedMessage id='taxable_benefits.Remove' />
              </ActionLink>}
            </div>
          </div>
          <FormLayout.Group>
            <Input value={tier.rate}
              onChange={e => tier.merge({rate: e.target.value})}
              label='taxable_benefits.Rate'
              placeholder='50%'
              translatePlaceholder={false}
              errorMessage={_.get(errors, `coverageVolumeTiers[${tier.order}].rate`)}
            />
            <Input value={tier.volumeBand}
              onChange={e => tier.merge({volumeBand: e.target.value})}
              label='taxable_benefits.Volume Band'
              placeholder='$5000'
              translatePlaceholder={false}
              helpMessage={t('taxable_benefits.help_text.volume_band', {min: currentCoverage.minRangeForTier(tier), max: currentCoverage.maxRangeForTier(tier)})}
              translateHelpMessage={false}
              errorMessage={_.get(errors, `coverageVolumeTiers[${tier.order}].volumeBand`)}
            />
          </FormLayout.Group>
        </div>
      )}
      <ActionLink onClick={() => uiState.addCoverageVolumeTier()}>
        <FormattedMessage id='taxable_benefits.+ Add Tier'/>
      </ActionLink>
    </FormLayout>
  );
});

export default TieredCoverageVolumeForm;
